import { useTranslation } from '@eti/providers';
import { useRef } from 'react';
import SingleChoice from '../../single-choice/containers/SingleChoiceContainer';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { TRAVEL_DOCS_POST } from '../../products';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import { jsx as _jsx } from "react/jsx-runtime";
export const texts = {
  additionalInformation: 'travelDocsPostAdditionalInformation',
  persuasionContent: 'travelDocsPostPersuasionContent',
  readMoreContent: 'travelDocsPostReadMoreModalContent',
  text: 'travelDocsPostAbstract',
  title: 'travelDocsPostTitle',
  upSell: 'travelDocsPostUpSellText'
};
const TravelDocsPost = _ref => {
  let {
    className,
    form,
    order,
    productPosition,
    shouldShowImage,
    shouldShowMandatoryChoiceText
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    additionalInformation,
    persuasionContent,
    readMoreContent,
    text,
    title,
    upSell
  } = getTranslatedTexts(texts, t);
  const rootElement = useRef(null);
  useProductSnowplowTracking(TRAVEL_DOCS_POST.name, {
    rootElement
  });
  return /*#__PURE__*/_jsx("div", {
    ref: rootElement,
    children: /*#__PURE__*/_jsx(SingleChoice, {
      additionalInformation: additionalInformation,
      className: className,
      form: form,
      order: order,
      persuasionContent: persuasionContent,
      productId: TRAVEL_DOCS_POST.id,
      productName: TRAVEL_DOCS_POST.name,
      productPosition: productPosition,
      readMoreContent: readMoreContent,
      rootElement: rootElement,
      shouldShowImage: shouldShowImage,
      shouldShowMandatoryChoiceText: shouldShowMandatoryChoiceText,
      text: text,
      title: title,
      typename: "none",
      upSell: upSell
    })
  });
};
export default TravelDocsPost;
//# sourceMappingURL=TravelDocsPost.js.map